import { identify, makeRequest, Service } from 'utils/http';

export async function getLoggedInUserApi() {
  return makeRequest(Service.getLoggedInUser(await identify()));
}
